import { useState } from 'react'
import { Link } from 'react-router-dom'
import InputUser from '../../components/FormControl/input/InputUser'
import { useSnackbar } from 'notistack'
import Template from '../../components/layout/Public'
import Grid from '@mui/material/Grid'
import isEmpty from 'lodash/isEmpty'
import { resetPassword } from '../../services/auth/auth.service'
import ButtonStartIcon from '../../components/button/ButtonStartIcon'
import { validate } from '../../utils'

const PasswordReset = () => { 
	const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const onChange = (value) => {
    setEmail(value)
    if (value) {
      setError('')
    }
  }
  const onSubmit = async (e) => {
    e.preventDefault()
    const rules = {
      email: 'required|email'
    }

    const errors = validate(rules, { email })
    if (!isEmpty(errors)) {
      setError(errors.email)
      return
    }
    try {
      setLoading(true)
      const response = await resetPassword({ email });
      setLoading(false)
      if (response.error) {
        setError(response?.error?.message || 'Something went wrong. Please try again.')
        return;
      }
      enqueueSnackbar('Email sent successfully', { variant: 'success' })
    } catch (err) {
      setLoading(false)
      const { response } = err
      if (response?.data) {
        const { error } = response.data
        setError(error.message)
        return
      }
      setError('Something went wrong. Please try again.')
    }
  }

  return (
    <Template title='Enter your username to reset your password'>
      <Grid container item xs={12} spacing={2}>
        <Grid item xs={12}>
          <InputUser
            error={error}
            onChange={(e) => onChange(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <ButtonStartIcon
            size='medium'
            loading={loading}
            className="login-button"
            onClick={onSubmit}
            startIcon='paper-plane'
          >
            submit
          </ButtonStartIcon>
        </Grid>
      </Grid>
      <Link to='/login' className='text-right-login'>
        Back to login
      </Link>
    </Template>
  )
}

export default PasswordReset;
